{
  "add": "Add",
  "edit": "Edit",
  "delete": "Delete",
  "save": "Save",
  "cancel": "Cancel",
  "close": "Close",
  "confirm": "Confirm",
  "done": "Done",
  "search": "Search...",
  "searchPlaceholder": "Search...",
  "filter": "Filter",
  "clear": "Clear",
  "loading": "Loading...",
  "error": "Error",
  "success": "Success",
  "warning": "Warning",
  "info": "Info",
  "yes": "Yes",
  "no": "No",
  "ok": "OK",
  "back": "Back",
  "brandWordmark": "Homy",
  "backToHome": "Back to HomyOS",
  "next": "Next",
  "previous": "Previous",
  "submit": "Submit",
  "saving": "Saving...",
  "change": "Change",
  "inactive": "Inactive",
  "reset": "Reset",
  "select": "Select",
  "selected": "Selected",
  "all": "All",
  "none": "None",
  "export": "Export",
  "general": "General",
  "or": "or",
  "actions": {
    "title": "Actions",
    "save": "Save",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "close": "Close",
    "confirm": "Confirm",
    "back": "Back",
    "next": "Next",
    "view": "View",
    "filter": "Filter",
    "reset": "Reset",
    "create": "Create",
    "add": "Add",
    "done": "Done",
    "submit": "Submit"
  },
  "state": {
    "loading": "Loading...",
    "saving": "Saving...",
    "submitting": "Submitting...",
    "processing": "Processing..."
  },
  "saveFailed": "Failed to save",
  "details": "Details",
  "contextualHelp": {
    "trigger": "Help & Guidance",
    "openHelp": "Open help",
    "closeHelp": "Close help",
    "needMoreHelp": "Need more help? Visit Help Center"
  },
  "view": "View",
  "copy": "Copy",
  "copied": "Link Copied!",
  "clickToCopy": "Click to copy",
  "copyFailed": "Could not copy link",
  "share": "Share",
  "toast": {
    "copyErrorDetails": "Copy error details",
    "copied": "Copied"
  },
  "download": "Download",
  "upload": "Upload",
  "remove": "Remove",
  "create": "Create",
  "update": "Update",
  "name": "Name",
  "email": "Email",
  "phone": "Phone",
  "call": "Call",
  "address": "Address",
  "date": "Date",
  "pickDate": "Pick a date",
  "monthsShort": [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  "time": "Time",
  "status": {
    "title": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "draft": "Draft",
    "archived": "Archived"
  },
  "type": "Type",
  "description": "Description",
  "required": "Required",
  "optional": "Optional",
  "unassigned": "Unassigned",
  "nav": {
    "dashboard": "Dashboard",
    "inbox": "Inbox",
    "listings": "Listings",
    "properties": "Properties",
    "visits": "Visits",
    "bookings": "Bookings",
    "availability": "Availability",
    "eventTypes": "Event types",
    "applications": "Applications",
    "rentals": "Rentals",
    "pipelines": "Workflows",
    "workflows": "Workflows",
    "calendar": "Calendar",
    "maintenance": "Maintenance",
    "vendorCockpit": "Work Hub",
    "maintenanceRequests": "Requests",
    "projects": "Projects",
    "standingServices": "Standing Services",
    "vendors": "Vendors",
    "marketplace": "Marketplace",
    "vendorStatements": "Statements",
    "support": "Support",
    "residentSupport": "Support",
    "orgSupport": "Support Queue",
    "helpCenter": "Help Center",
    "tasks": "Tasks",
    "databases": "Databases",
    "organizations": "Organization",
    "issues": "Issues",
    "landingPage": "Landing Page",
    "trust": "Trust & Verification",
    "settings": "Settings",
    "tenantLease": "My Lease",
    "tenantPayments": "Payments",
    "toggleGroup": "Toggle {{group}} section",
    "openGroup": "Open {{group}} menu",
    "mainNavigation": "Main navigation",
    "group": {
      "portfolioMarketing": "Portfolio & marketing",
      "leasing": "Leasing",
      "schedule": "Schedule",
      "maintenance": "Maintenance",
      "workComms": "Work & communications",
      "dataOrg": "Data & organization"
    },
    "documents": "Documents"
  },
  "organization": {
    "fallback": "Organization",
    "manage": "Manage organization",
    "switch": "Switch organization"
  },
  "viewAll": "View All",
  "expandSidebar": "Expand sidebar",
  "collapseSidebar": "Collapse sidebar",
  "collapse": "Collapse",
  "openMenu": "Open menu",
  "toggleTheme": "Toggle theme",
  "theme": {
    "toggle": "Toggle theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "changeLanguage": "Change language",
  "morePages": "More pages",
  "notifications": "Notifications",
  "platformConsole": "Platform Console",
  "userFallback": "HomyOS User",
  "roleFallback": "Manager",
  "userMenu": {
    "openMenu": "Open account menu",
    "profile": "Profile & preferences",
    "organization": "Organization",
    "security": "Security"
  },
  "logout": "Log out",
  "visits": {
    "title": "Visits",
    "upcomingTitle": "Upcoming Visits",
    "upcomingVisits": "Upcoming Visits",
    "availability": "Availability",
    "empty": "No upcoming visits.",
    "failedToLoad": "Failed to load visits",
    "failedToUpdate": "Failed to update visit",
    "property": "Property",
    "date": "Date",
    "status": "Status",
    "confirm": "Confirm",
    "cancel": "Cancel Visit",
    "markNoShow": "Mark No-Show",
    "visitor": "Visitor",
    "configureAvailability": "Configure",
    "sameHoursEveryDay": "Same hours every day",
    "whichDays": "Which days?",
    "whatHours": "What hours?",
    "to": "to",
    "howLongEachVisit": "How long is each visit?",
    "slotsPerDay": "{{count}} slots/day",
    "slotsPerWeek": "{{count}} slots/week",
    "minVisits": "{{count}} min visits",
    "noAvailability": "No availability configured",
    "saveAvailability": "Save Availability",
    "availabilitySaved": "Availability saved",
    "failedToSave": "Failed to save availability",
    "minuteAbbrev": "min",
    "yourSchedule": "Your Schedule",
    "yourScheduleDescription": "Set your default availability for visits",
    "perProperty": "Per Property",
    "usingDefault": "Using your schedule",
    "custom": "Custom",
    "applyToAll": "Apply to all",
    "applyToAllConfirm": "This will replace availability for all properties with your general schedule. Continue?",
    "saveSchedule": "Save Schedule",
    "scheduleSaved": "Schedule saved",
    "failedToSaveSchedule": "Failed to save schedule"
  },
  "errorBoundary": {
    "title": "Something went wrong",
    "message": "An unexpected error occurred. Please try refreshing the page or go back to the home page.",
    "refresh": "Refresh Page",
    "goHome": "Go to Home"
  },
  "notFound": {
    "code": "404 Error",
    "title": "Page Not Found",
    "description": "The page you are looking for doesn't exist, has been removed, or was moved to another URL.",
    "returnHome": "Return to Dashboard"
  },
  "apiError": {
    "default": "Something went wrong. Please try again.",
    "network": "Network error. Check your connection and try again."
  },
  "dataTable": {
    "rowsPerPage": "Per page",
    "showing": "Showing {{start}}–{{end}} of {{total}}",
    "sortAscending": "Sort ascending",
    "sortDescending": "Sort descending",
    "clearSort": "Clear sort",
    "noResults": "No results."
  },
  "dateRangePicker": {
    "placeholder": "Select date range",
    "clear": "Clear date range",
    "presets": {
      "today": "Today",
      "last7": "Last 7 days",
      "last30": "Last 30 days",
      "mtd": "Month to date",
      "ytd": "Year to date"
    }
  },
  "list": {
    "filters": {
      "title": "Filters",
      "active": "active",
      "clearAll": "Clear filters",
      "removeFilter": "Remove {{filter}}",
      "dateRange": "Date Range",
      "selectDateRange": "Filter by date range"
    },
    "viewMode": {
      "label": "View mode",
      "table": "Table",
      "thumbnails": "Cards",
      "grid": "Grid",
      "list": "List",
      "map": "Map",
      "kanban": "Kanban",
      "split": "Split"
    },
    "map": {
      "missingKeyTitle": "Map unavailable",
      "missingKeyDescription": "Configure VITE_GOOGLE_MAPS_API_KEY to enable map view.",
      "loadFailedTitle": "Map failed to load",
      "loadFailedDescription": "Check your connection and try again.",
      "noLocationsTitle": "No locations",
      "noLocationsDescription": "None of the items have coordinates to show on the map."
    }
  },
  "profile": "Profile",
  "settings": "Settings",
  "approvals": {
    "title": "Approvals",
    "history": "Approval History",
    "pending": "Pending Approvals",
    "noPending": "No pending approvals found.",
    "noHistory": "No approval records for this item.",
    "status": {
      "PENDING": "Pending",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "CANCELLED": "Cancelled",
      "EXPIRED": "Expired",
      "NEEDS_CLARIFICATION": "Needs Clarification"
    },
    "strategy": {
      "SINGLE": "Single Approver",
      "ANY_OF": "Any Approver",
      "ALL_OF": "All Approvers",
      "SEQUENTIAL": "Sequential"
    },
    "actions": {
      "approve": "Approve",
      "reject": "Reject",
      "cancel": "Cancel Request",
      "review": "Review",
      "submitting": "Submitting..."
    },
    "dialog": {
      "approveTitle": "Approve Request",
      "rejectTitle": "Reject Request",
      "cancelTitle": "Cancel Approval Request",
      "notesLabel": "Review Notes",
      "notesPlaceholder": "Add your comments or reasoning (optional)...",
      "reasonLabel": "Cancellation Reason",
      "reasonPlaceholder": "Explain why this request is being cancelled...",
      "confirmApprove": "Confirm Approval",
      "confirmReject": "Confirm Rejection",
      "confirmCancel": "Confirm Cancellation"
    },
    "step": "Step {{order}}",
    "request": "Request",
    "requestedBy": "Requested by",
    "assignedTo": "Assigned to",
    "resolvedBy": "Resolved by",
    "requestedAt": "Requested at",
    "resolvedAt": "Resolved at",
    "notes": "Notes",
    "entityType": "Entity",
    "approvalType": "Approval Type"
  },
  "unsavedChanges": {
    "title": "Discard changes?",
    "description": "Unsaved changes will be lost if you close this panel.",
    "keepEditing": "Keep Editing",
    "discard": "Discard Changes"
  },
  "security": {
    "restricted": "Restricted",
    "masked": {
      "restrictedValue": "••••••",
      "restrictedTooltip": "Restricted financial information"
    },
    "lockedMetricTooltip": "This financial metric is restricted by organization policy.",
    "unauthorized": {
      "title": "Access Restricted",
      "description": "You do not have permission to view this content."
    }
  },
  "retry": "Retry",
  "brandLogoAlt": "HomyOS",
  "brandOs": "OS",
  "clearSearch": "Clear search",
  "more": "More",
  "progress": "Progress",
  "created": "Created",
  "statusLabel": "Status",
  "id": "ID",
  "filters": {
    "primaryStateFilters": "Primary state filters"
  },
  "impersonation": {
    "activeAria": "Diagnostic Impersonation Active",
    "badgeTitle": "Diagnostic Impersonation",
    "badge": "Impersonated",
    "viewingAs": "Viewing as",
    "in": "in",
    "readOnlyGuard": "Read-Only Guard Active",
    "writeAllowed": "Write Allowed",
    "ttl": "30m TTL",
    "operator": "Operator:",
    "endSession": "End Diagnostic Session",
    "exit": "Exit Impersonation"
  },
  "countryOptions": {
    "chile": "Chile (CLP / UF)",
    "argentina": "Argentina (ARS / USD)",
    "unitedStates": "United States (USD)",
    "mexico": "Mexico (MXN)",
    "brazil": "Brazil (BRL)",
    "colombia": "Colombia (COP)",
    "spain": "Spain (EUR)",
    "portugal": "Portugal (EUR)"
  },
  "landingPagePreview": "Landing page preview",
  "landingPagePreviewError": "Could not load landing page preview",
  "views": {
    "switcher": "Switch Application View",
    "operations": "Operations",
    "resident": "Resident",
    "contractor": "Contractor"
  },
  "fileDropzone": {
    "promptTitle": "Drag and drop file here",
    "promptSubtitle": "Supports PDF, Images up to {{maxSizeMB}}MB",
    "browse": "Browse files",
    "uploading": "Uploading...",
    "ready": "Ready",
    "failed": "Failed",
    "preview": "Preview",
    "download": "Download",
    "remove": "Remove file",
    "close": "Close",
    "empty": "No files attached yet",
    "previewUnavailable": "Inline preview is not available for this file."
  },
  "notificationPopover": {
    "title": "Notifications",
    "markAllRead": "Mark all read",
    "markRead": "Mark as read",
    "all": "All",
    "unread": "Unread",
    "emptyTitle": "All caught up",
    "emptyUnread": "No unread notifications",
    "emptyAll": "No recent notifications",
    "viewAll": "View all in Operations Inbox"
  },
  "auditTimeline": {
    "today": "Today",
    "yesterday": "Yesterday",
    "activity": "Audit Log",
    "eventSingular": "{{count}} event",
    "eventPlural": "{{count}} events",
    "emptyTitle": "No audit events recorded",
    "emptySubtitle": "Audit milestones and events will appear here."
  },
  "editableCell": {
    "save": "Save (Enter)",
    "cancel": "Cancel (Esc)",
    "invalidValue": "Invalid value",
    "saveError": "Failed to save",
    "selectPlaceholder": "Select..."
  }
}
